/* global I18n */

import ajax from "ajax"
import url_helper from "url_helper"
import helpscout_beacon from "helpscout_beacon"
import {Controller} from "@hotwired/stimulus"

class HelpscoutController extends Controller {
  connect() {
    if (window.gon.current_user?.message_waiting) {
      this.open_message_waiting_notification()
    }
    const hash = url_helper.get_hash()
    if (hash.match(/contact_.*/)) this.open_beacon()
    if (hash.match(/helpscout_docs\/(.*)/)) this.open_docs()
  }

  open_beacon(e) {
    const payload = e?.params?.payload || {}
    const beaconText = e?.currentTarget?.dataset?.helpscoutBeaconText || ""
    const url = e ? e.currentTarget.href : window.location.href
    if (url?.match("contact_us")) payload.ask = true

    const Beacon = helpscout_beacon(payload)
    Beacon("prefill", {text: beaconText})
    Beacon("open")
  }

  open_docs(e) {
    const url = e ? e.currentTarget.href : window.location.href
    const match = url?.match(/helpscout_docs\/(.*)/)
    // for now, we only have one type of doc, but in future we can add a switch
    if (match && match[1] !== "payment_problems") return

    const Beacon = helpscout_beacon({})
    // opens the payment problems helpscout doc
    Beacon("article", I18n.t("js.payment.errors.payment_problems_doc_id"))
    Beacon("open")
  }

  open_message_waiting_notification() {
    const Beacon = helpscout_beacon()
    Beacon("on", "open", () =>
      ajax.post(`/${window.gon.locale}/profile/hide_message_waiting`)
    )
    Beacon("navigate", "/previous-messages/")
    Beacon("config", {
      hideFABLabelOnMobile: true,
      display: {
        style: "iconAndText",
        text: I18n.t("js.helpscout.message_waiting"),
        textAlign: "right",
        iconImage: "beacon",
        position: "right"
      }
    })
  }
}

export default HelpscoutController
